import React from "react";
import { cva } from "class-variance-authority";
import { cn } from "../../lib/cn";

const badgeStyles = cva(
  "inline-flex items-center gap-1 rounded px-2 py-0.5 text-xs font-medium",
  {
    variants: {
      variant: {
        default:
          "bg-neutral-100 dark:bg-neutral-800 text-neutral-700 dark:text-neutral-200",
        secondary:
          "bg-neutral-100 dark:bg-neutral-800 text-neutral-600 dark:text-neutral-300 border border-neutral-200 dark:border-neutral-700",
        primary:
          "bg-primary-50 text-primary-700 dark:bg-primary-900/40 dark:text-primary-300",
        accent:
          "bg-accent-50 text-accent-700 dark:bg-accent-900/40 dark:text-accent-300",
        success:
          "bg-success-50 text-success-700 dark:bg-success-700/25 dark:text-success-50",
        warning:
          "bg-warning-50 text-warning-700 dark:bg-warning-700/25 dark:text-warning-50",
        danger:
          "bg-danger-50 text-danger-700 dark:bg-danger-700/25 dark:text-danger-50",
        purple:
          "bg-purple-50 text-purple-700 dark:bg-purple-900/40 dark:text-purple-300",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
);

/**
 * Badge
 * @param {"default"|"secondary"|"primary"|"accent"|"success"|"warning"|"danger"|"purple"} [variant="default"]
 * @param {string} [className]
 * @param {React.ReactNode} children
 */
export function Badge({ variant = "default", className, children, ...props }) {
  return (
    <span className={cn(badgeStyles({ variant }), className)} {...props}>
      {children}
    </span>
  );
}
